import api from './index';
import axiosCancel from 'axios-cancel';

axiosCancel(api, {
  debug: false,
});

export default {
  getUser() {
    return api.get('/personal/user');
  },
};
